// 菜单 侧栏
export default [{
  path: '/index',
  title: '首页'
},
{
  path: '/list/主席信箱',
  title: '主席信箱',
  type: [{
    title: '工会活动',
    code: '0'
  }, {
    title: '活动分享',
    code: '1'
  }, {
    title: '工会集锦',
    code: '0'
  }, {
    title: '家庭日',
    code: '0'
  }, {
    title: '篮球赛',
    code: '0'
  }]
},
{
  path: '/list/工会信息',
  title: '工会信息'
},
{
  path: '/list/工会活动',
  title: '工会活动'
},
{
  path: '/list/工会集锦',
  title: '工会集锦'
},
{
  path: '/list/工会福利',
  title: '工会福利'
},
{
  path: '/list/身边的代表',
  title: '身边的代表'
},
{
  path: '/list/职代会代表专线',
  title: '职代会代表专线'
},
{
  path: '/list/我的专线',
  title: '我的专线'
},
{
  path: '/list/积分兑换',
  title: '积分兑换'
},
{
  path: '/list/我的任务',
  title: '我的任务'
},
{
  path: '/list/后台',
  title: '后台'
},
]